import { Component, OnInit } from '@angular/core';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ChatService } from '../../service/chat-service';
import { MaintenanceDialogService } from '../../service/shared/maintenance-dialog.service';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(
    private intService: InteractionService,
    private maintenanceDialogService: MaintenanceDialogService
  ) { }

  ngOnInit(): void {
  // hide header and sidebar
  this.intService.hideComponentHandler({hideHeader: true, hideSidebar: true});
  }
  login() {
    this.maintenanceDialogService.checkScheduleOutage().then((isScheduleOutage:boolean)=>{
      if (!isScheduleOutage) {
        location.reload();
      }
    });
  }
 
}
